import { Env } from '../../core/env';
import { ApiClient } from '../../core/http/api_client';
import {
  RecommendationItemResponse
} from '../../search/addRecommendationItem/models/folders';

type UpdateRecommendationR1Response = {
  // "0":正常
  // "1":ビジネスエラー
  // "100":セッションエラー用文字列"
  result: '0';
  '1';
  '100';
  errMessage?: string;
};

export class ListRecommendationItemRepository {
  async getRecommendationFolders(): Promise<RecommendationItemResponse> {
    return ApiClient.get(
      `${Env.SETTING.userPublicApi.urlBase}api/attract/item/recommendationItemFolders`,
      {}
    );
  }

  async upsertRecommendationItem(
    supplierId: string,
    catalogItemCode: string,
    itemGroupCode = '', // バリエーションCD
    folderId = '',
    folderName = '',
  ) {
    /* R2は下記利用：
    const request = {
      isCreateFolder: false,
      folderType: folderType,
      supplierId: supplierId || '',
      catalogItemCode: catalogItemCode || '',
      itemGroupCode: itemGroupCode || '',
      recommendationItemFolderId: folderId || '',
      recommendationItemFolderName: folderName
    };
    return ApiClient.post(
      `${Env.SETTING.userPublicApi.urlBase}api/attract/item/recommendationItem`,
      request
    );
    */
    // R1は現行ソロアリ呼び出す
    return ApiClient.get(`${Env.SETTING.soloareApi.urlBase}buyer/view/a910/teeda.ajax`, {
      params: {
        component: 'b090_rcmndFldrItemAjaxPage',
        action: 'ajaxDirectAddItems',
        time: new Date(),
        param: {
          itemKeys: [
            {
              supId: supplierId,
              ctgItemCd: catalogItemCode,
              itemGrpCd: itemGroupCode
            }
          ],
          isNewFldr: !folderId,
          rcmndFldrId: folderId,
          rcmndFldrName: folderName,
          isBulkRegist: false
        }
      }
    }).then((res: UpdateRecommendationR1Response) => {
      if (res.result !== '0') {
        throw new Error(res.errMessage || '想定外のエラーが発生しました。');
      }
    });
  }

  async createFolder(supplierId: string, catalogItemCode: string, itemGroupCode: string) {
    const folderName = document.getElementById('foldername04') as HTMLInputElement;
    /* R2は下記利用：
    const folderType = document.querySelector(
      'input[name="add-recommendation-create-folder"]:checked'
    ) as HTMLInputElement;
    const request = {
      isCreateFolder: true,
      folderType: folderType.value,
      supplierId: supplierId || '',
      catalogItemCode: catalogItemCode || '',
      itemGroupCode: itemGroupCode || '',
      recommendationItemFolderId: '',
      recommendationItemFolderName: folderName.value
    };
    return ApiClient.post(
      `${Env.SETTING.userPublicApi.urlBase}api/attract/item/recommendationItem`,
      request
    );
    */
    // R1は現行ソロアリ呼び出す
    return this.upsertRecommendationItem(
      supplierId,
      catalogItemCode,
      itemGroupCode,
      '',
      folderName.value,
    );
  }
}
